import { render, staticRenderFns } from "./article10.vue?vue&type=template&id=7de9b4e0&scoped=true"
var script = {}
import style0 from "./article10.vue?vue&type=style&index=0&id=7de9b4e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de9b4e0",
  null
  
)

export default component.exports